import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Clock, Instagram, ExternalLink } from 'lucide-react';
import { restaurantInfo } from '../../data/mock';
import { useLanguage } from '../../context/LanguageContext';

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="bg-[#0f172a] text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div>
            <img
              src={restaurantInfo.logo}
              alt="Ya Habibi Logo"
              className="h-20 w-auto mb-6"
            />
            <p className="text-gray-400 leading-relaxed">
              {t('footer', 'description')}
            </p>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-serif text-xl font-semibold mb-6 text-[#E8D4BE]">{t('footer', 'contact')}</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin size={20} className="text-[#D4A853] mt-1 flex-shrink-0" />
                <span className="text-gray-300">{restaurantInfo.address}</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={20} className="text-[#D4A853] flex-shrink-0" />
                <span className="text-gray-300">{restaurantInfo.phone}</span>
              </li>
              <li className="flex items-center gap-3">
                <Mail size={20} className="text-[#D4A853] flex-shrink-0" />
                <span className="text-gray-300">{restaurantInfo.email}</span>
              </li>
            </ul>
          </div>

          {/* Hours */}
          <div>
            <h3 className="font-serif text-xl font-semibold mb-6 text-[#E8D4BE]">{t('footer', 'hours')}</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <Clock size={20} className="text-[#D4A853] mt-1 flex-shrink-0" />
                <div>
                  <p className="text-green-400 font-medium">{t('footer', 'open7')}</p>
                </div>
              </li>
              <li className="flex items-start gap-3 ml-8">
                <div>
                  <p className="text-gray-300">{restaurantInfo.hours.weekdaysLabel}</p>
                  <p className="text-gray-400 text-sm">{restaurantInfo.hours.weekdays}</p>
                </div>
              </li>
              <li className="flex items-start gap-3 ml-8">
                <div>
                  <p className="text-gray-300">{restaurantInfo.hours.weekendLabel}</p>
                  <p className="text-gray-400 text-sm">{restaurantInfo.hours.weekend}</p>
                </div>
              </li>
            </ul>
          </div>

          {/* Links & Social */}
          <div>
            <h3 className="font-serif text-xl font-semibold mb-6 text-[#E8D4BE]">{t('footer', 'followUs')}</h3>
            <div className="flex gap-4 mb-8">
              <a
                href={restaurantInfo.social.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="w-12 h-12 bg-[#1e293b] rounded-full flex items-center justify-center hover:bg-[#D4A853] transition-colors duration-200"
                aria-label="Instagram"
              >
                <Instagram size={22} />
              </a>
              <a
                href={restaurantInfo.social.googleBusiness}
                target="_blank"
                rel="noopener noreferrer"
                className="w-12 h-12 bg-[#1e293b] rounded-full flex items-center justify-center hover:bg-[#D4A853] transition-colors duration-200"
                aria-label="Google Business"
              >
                <ExternalLink size={22} />
              </a>
            </div>

            <h4 className="font-semibold mb-3 text-gray-300">{t('footer', 'navigation')}</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/menu" className="text-gray-400 hover:text-[#ECEC75] transition-colors">{t('nav', 'menu')}</Link>
              </li>
              <li>
                <Link to="/reservation" className="text-gray-400 hover:text-[#ECEC75] transition-colors">{t('nav', 'book')}</Link>
              </li>
              <li>
                <Link to="/evenements" className="text-gray-400 hover:text-[#ECEC75] transition-colors">{t('nav', 'events')}</Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-[#ECEC75] transition-colors">{t('nav', 'contact')}</Link>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800">
        <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-500 text-sm">
            &copy; {new Date().getFullYear()} Ya Habibi! Grill. {t('footer', 'allRights')}
          </p>
          <p className="text-gray-500 text-sm">
            {t('footer', 'subtitle')}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
